module.exports = "/assets/436ecc8505235e2b9531230af3c15dcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/FD.png
// module id = 1366
// module chunks = 0